import React from 'react'
import { AuthConsumer } from 'react-check-auth'
import { Route, Redirect, useLocation } from 'react-router-dom'
import { isAllowedPath } from './utils'

// MBQ OCT 2025 RESTYLING
import { useFeature } from '../contexts/Feature/FeatureContext'
import _ from 'lodash'
import LinkToNewApp from '../components/Links/LinkToNewApp'
import UX_TYPE from '../globals/uxType'
import ROLES from '../globals/userRoles'

const AuthRoute = ({ component: Component, routeProfile, portal, ...rest }) => {
  // MBQ OCT 2025 RESTYLING
  const { oldApp:oldAppOn, mainUxOldApp } = useFeature()
  const location = useLocation()
  
  // PREMIUM APP ON
  if(oldAppOn) {
    return (
      <AuthConsumer>
        {({ userInfo }) => (
          userInfo ?
            (
              userInfo.uxPreference === UX_TYPE.OLD_APP ?
                (
                  isAllowedPath(userInfo.profile, routeProfile, portal) ?
                    <Route {...rest} render={props => <Component {...props} />} />
                    :
                    <Redirect to='/error' />
                )
                :
                (
                  (
                    (/^\/administration/.test(location.pathname)) ||
                    (
                      /^\/($|admin|edit)($|\/.*)/.test(location.pathname) &&
                      [ROLES.INVOICE, ROLES.CUSTOMER_SUPPORT, ROLES.INTERNAL_SUPPORT].includes(userInfo.role)
                    )
                  ) ?
                    isAllowedPath(userInfo.profile, routeProfile, portal) ?
                      <Route {...rest} render={props => <Component {...props} />} />
                      :
                      <LinkToNewApp />
                    :
                    <LinkToNewApp />
                )
            )
            :
            (
              mainUxOldApp ?
              (
                <Redirect to={{ pathname: '/home', state: { referrer: window.location.href } }} />
              )
              :
              (
                <LinkToNewApp />
              )              
            )
        )}
      </AuthConsumer>
    )
  }
  // PREMIUM APP OFF (ADMIN PANEL ONLY)
  else {
    return (
      <AuthConsumer>
        {({ userInfo }) => (
          userInfo ?
            (
              isAllowedPath(userInfo.profile, routeProfile, portal) ?
                <Route {...rest} render={props => <Component {...props} />} />
                :
                <LinkToNewApp />
            )
            :
            (
              <LinkToNewApp />
            )
        )}
      </AuthConsumer>
    )
  }
}

export default AuthRoute